import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../layout/Header.jsx';
import ListOpens from '../../lists/ListOpens.jsx';

const PageOpens = () => {
  const { t } = useTranslation();
  return (
  <div>
    <Header>{t('Opens')}</Header>
    <ListOpens deactivateAll='opens'/>
  </div>
  );
};

export default PageOpens;
